import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Checkbox, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Terms from "../../../../assets/user/Terms.jsx";
import LoadableButton from "../../../buttons/LoadableButton.jsx";
import { setUserDetails } from "../../../../store/Slices/userSlice.js";
import { GetTermsAndConditionApi, TermsAndConditionAcceptApi } from "../../../../api/request/common.js";
import { handleApiError } from "../../../../utils/handleApiError.js";

export default function TermsAndConditionsPopup() {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { userDetails } = useSelector((state) => state.user);
    const [tnc, setTnc] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const getTermsAndCondition = async () => {
        try {
            const { data } = await GetTermsAndConditionApi();
            if (data?.success) setTnc(data?.data?.[0]);
        } catch (error) { }
    };

    const handleAccept = async () => {
        try {
            setIsLoading(true);
            const { data: response } = await TermsAndConditionAcceptApi(userDetails?._id);
            if (response?.success) {
                dispatch(setUserDetails({ ...userDetails, isAcceptTermsAndCondition: true }));
                toast.success(response?.message);
                form.resetFields();
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        getTermsAndCondition();
    }, []);


    return (
        <div className={`max-w-lg w-full bg-white shadow-lg rounded-lg ring-1 ring-black ring-opacity-5 fixed top-10 right-10 z-50`}>
            <div className="p-4 space-y-4">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center rounded-full bg-gray-200 p-3"><Terms className="size-8" /></div>
                    <p className="primary text-xl font-semibold">Terms & Conditions</p>
                </div>
                <p className="text-[#2F2B3DB2] text-base">Please read and accept the New Terms & Conditions to continue using the app.</p>
                <Form layout="vertical" autoComplete="off" form={form} onFinish={handleAccept}>
                    <Form.Item
                        name="conditions"
                        valuePropName="checked"
                        rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error("Please accept the terms and conditions.")) }]}
                    >
                        <Checkbox className="mt-1">Yes, I agreed to the Terms and conditions</Checkbox>
                    </Form.Item>
                    <div className="flex flex-wrap gap-2 text-sm">
                        {Array.isArray(tnc?.termsAndConditions) && tnc?.termsAndConditions
                            .filter(doc => !!doc?.fileUrl)
                            .map((doc, index, arr) => {
                                const url = String(doc.fileUrl || '').replace(/[`]/g, '').trim();
                                const label = doc.label || doc.fileName || 'View Document';
                                return (
                                    <span key={doc.id || index}>
                                        <a href={url} target="_blank" rel="noopener noreferrer" className="primary underline hover:underline duration-300 ms-1">
                                            {label}
                                        </a>
                                        {index !== arr.length - 1 && ','}
                                    </span>
                                );
                            })}
                    </div>
                    <div className="mt-4">
                        <LoadableButton type="submit" className="bg-primary text-white font-semibold text-lg rounded-lg w-full py-2" lable="Accept Terms & Conditions" isLoading={isLoading} loadingLable="Accepting..." />
                    </div>
                </Form>
            </div>
        </div>
    );
}
